export enum OrganizationStatuses {
  DISTRIBUTOR = 'distributor',
  MANUFACTORER = 'manufactorer',
  OTHER = 'other',
}
